import {Injectable} from '@angular/core';
import {HttpErrorResponse,HttpEvent,HttpHandler,HttpInterceptor,HttpRequest} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '@domain/appstate';
import {Observable,of,throwError} from "rxjs";
import {SESSION_EXPIRED} from "@reducers/session";
import {catchError} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {LoginComponent} from "@share/login/login.component";
import {PayloadSessionExpired} from "@domain/action";

@Injectable()
export class DefaultRequestInterceptor implements HttpInterceptor {
	/**
	 * Constructeur
	 */
	constructor(private store: Store<AppState>,private route: ActivatedRoute) {
	}

	intercept(request: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {
		//Interception des erreurs lors de la réponse du serveur
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				const delog: boolean = error.url.includes('?') && error.url.split('?')[1].split('&').map(param => {
					const paramValue = param.split('=');
					return paramValue.length == 2 && paramValue[0] === 'error' && paramValue[1] === 'deLog';
				}).includes(true);

				//Vérification du composant actif pour la route courante pour déterminer si on est déjà sur la page de login (il y a plusieurs routes possibles pour le composant)
				const isOnLogin = this.route.firstChild.routeConfig.component == LoginComponent;

				//Vérification du code d'erreur 401 Unauthorized utilisé pour notifier que la session (serveur) est expirée
				if ((delog || error.status === 401) && !isOnLogin) {
					//Demande du reset de la session (client) via le store
					this.store.dispatch({
						type: SESSION_EXPIRED,
						payload: {
							error: error.headers?.get("error")
						} as PayloadSessionExpired
					});

					//Retour d'une valeur nulle pour catcher l'erreur et éviter d'afficher le message d'erreur générique
					return of(null);
				} else {
					//Renvoi de l'erreur
					return throwError(error);
				}
			})
		)
	}
}
